function alpha(n, uppercase) {
    var mod = n % 26;
    var rem = n - mod;
    var prefix = "";
    if (rem > 0)
        prefix = alpha(rem / 26, uppercase);
    return prefix + String.fromCharCode((uppercase ? 65 : 97) + mod);
}
var romanDigits = [
    ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix"],
    ["x", "xx", "xxx", "xl", "l", "lx", "lxx", "lxxx", "xc"],
    ["c", "cc", "ccc", "cd", "d", "dc", "dcc", "dccc", "cm"],
    ["m", "mm", "mmm", "mmmm", "mmmm", "mmmmm", "mmmmmm", "mmmmmmm", "mmmmmmmm", "mmmmmmmmm"]
];
function roman(n, uppercase) {
    if (isNaN(n) || n < 1 || n > 9999 || Math.floor(n) !== n)
        throw new TypeError("Roman numeral out of valid range.");
    n = String(n)
        .split("")
        .reverse();
    for (var i = 0; i < n.length; i++) {
        n[i] = romanDigits[i][n[i] - 1];
    }
    var ret = n.reverse().join("");
    if (uppercase)
        ret = ret.toUpperCase();
    return ret;
}
module.exports = {
    none: "",
    disc: "\u2022",
    circle: "\u006f",
    square: "\u225A0",
    decimal: function (i) {
        return i + 1 + ".";
    },
    "lower-roman": function (i) {
        return roman(i + 1) + ".";
    },
    "upper-roman": function (i) {
        return roman(i + 1, true) + ".";
    },
    "lower-alpha": function (i) {
        return alpha(i) + ".";
    },
    "lower-latin": function (i) {
        return alpha(i) + ".";
    },
    "upper-alpha": function (i) {
        return alpha(i, true) + ".";
    },
    "upper-latin": function (i) {
        return alpha(i, true) + ".";
    }
};
//# sourceMappingURL=module.js.map